import { render, staticRenderFns } from "./index.vue?vue&type=template&id=08b74556&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08b74556')) {
      api.createRecord('08b74556', component.options)
    } else {
      api.reload('08b74556', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=08b74556&", function () {
      api.rerender('08b74556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/u8-icon-btn/index.vue"
export default component.exports